define.alias("shared/components/shared/wizards/carousel/step-two", "calendar/components/shared/wizards/carousel/step-two");